import React from 'react';
import { ImageViewerModalProps } from './image-viewer-modal-types';

export const ImageViewerModal: React.FC<ImageViewerModalProps> = () => {
  // Images are opened in a new tab on web so return null
  return null;
};
